import { render, staticRenderFns } from "./aRoomDetailContract.vue?vue&type=template&id=661736a0&scoped=true"
import script from "./aRoomDetailContract.vue?vue&type=script&lang=js"
export * from "./aRoomDetailContract.vue?vue&type=script&lang=js"
import style0 from "./aRoomDetailContract.vue?vue&type=style&index=0&id=661736a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661736a0",
  null
  
)

export default component.exports